import styled from "styled-components"

import {
  EstimatesArrow as Arrow,
  EstimatesContainer as Container,
  EstimatesDivider as Divider,
  Text,
} from "../../../components/elements"
import { theme } from "../../../themes/theme"
import { IEstimates } from "../../bpo/types"

import { IEstimateParamsTableProps, ParamsTable } from "./ParamsTable"

interface IEstimateProps extends IEstimateParamsTableProps {
  results: IEstimates
}

const Label = styled.div`
  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);
  font-weight: 700;
  letter-spacing: 0.04em;

  display: flex;
  align-items: center;

  margin-block-start: 0.25em;
`
const Value = styled.span`
  display: block;

  color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fontFamilyEN};
  font-size: clamp(2rem, 1.6rem + 2vw, 4rem);
  font-weight: 700;
  letter-spacing: -0.011em;
`

const Unit = styled.span`
  display: block;

  font-size: clamp(0.75rem, 0.65rem + 0.5vw, 1.25rem);
  font-weight: 700;
  letter-spacing: 0.04em;

  margin-left: auto;
`

const Row = styled.div<{
  $coloredBackground?: boolean
  $px: string
  $py: string
}>`
  background-color: ${(props) =>
    props.$coloredBackground
      ? props.theme.colors.bodyBackground
      : props.theme.colors.boxBackground};
  padding: ${(props) => props.$px} ${(props) => props.$py};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 0.2rem;
  border-radius: 8px;
`

const ValueAndUnit = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 1rem;
`

const Estimates = (props: IEstimateProps) => {
  const { results, params, px, py } = props
  return (
    <Container>
      <Row $coloredBackground $px={px} $py={py}>
        <Label>
          月額
          <br />
          アウトソーシング価格
        </Label>
        <ValueAndUnit>
          <Value>{results.monthly_estimate.toLocaleString()}</Value>
          <Unit>円/月</Unit>
        </ValueAndUnit>
      </Row>

      <Divider bgColor={theme.colors.bodyBackground as "bodyBackground"} />

      <ParamsTable px={px} py={py} params={params} />

      <Arrow />

      <Row $px={px} $py={py}>
        <Label>年額換算</Label>
        <ValueAndUnit>
          <Value>{results.yearly_estimate.toLocaleString()}</Value>
          <Unit>円/年</Unit>
        </ValueAndUnit>
      </Row>

      <Divider bgColor={theme.colors.boxBackground as "boxBackground"} />

      <Row $px={px} $py={py}>
        <Label>
          情シス正社員換算
          <Text primary>*</Text>
        </Label>
        <ValueAndUnit>
          <Value>
            {results.fulltime_equivalent.toLocaleString("ja-JP", {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            })}
          </Value>
          <Unit>人分</Unit>
        </ValueAndUnit>
      </Row>
    </Container>
  )
}

export { Estimates }
